<template>
  <div>
    <ejs-treeview ref='cellTree' :fields='fields' :showCheckBox='true'></ejs-treeview>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import { EventBus } from '../../../plugins/eventBus';

const { mapGetters } = createNamespacedHelpers('trackConfig');
let responseData = [];
export default {
  name: 'cellTree',
  props: {
    hasBorder: { type: Boolean, default: false }
  },
  data() {
    return {
      fields: {
        dataSource: [],
        id: 'id',
        text: 'text',
        child: 'children',
        isChecked: 'checked'
      }
    };
  },
  computed: {
    ...mapGetters(['currentNe']),
  },
  methods: {
    // 查TOPO树数据
    getTopoTreeData() {
      const This = this;
      This.$axios.get(`/lte/ems/track/queryCellTree/${this.currentNe.id}`).then(response => {
        if (response && response.status === 200) {
          responseData = response.data.resultVal ? response.data.resultVal : [];
          This.fields = {
            dataSource: responseData,
            id: 'id',
            text: 'text',
            child: 'children',
            isChecked: 'checked'
          };
        } else {
          EventBus.$emit('toast', {type: 'error', content: This.$t('Track.error')});
        }
      });
    },
    // 获取当前显示树选中节点数组
    getCheckNodeList() {
      const treeObj = this.$refs.cellTree.ej2Instances;
      const checkIdList = treeObj.getAllCheckedNodes();
      const newList = [];
      for (let i = 0; i < checkIdList.length; i++) {
        if (!(treeObj.getNode(checkIdList[i]).hasChildren === true)) {
          newList.push(parseInt(checkIdList[i], 10));
        }
      }
      return newList;
    }
  },
  mounted() {
    this.getTopoTreeData();
  }
};
</script>
